/** Valida um CPF pelos dígitos verificadores, aceitando o valor com ou sem máscara. */
export function cpfValido(valor?: string | null): boolean {
  const digitos = String(valor ?? '').replace(/\D/g, '');

  if (digitos.length !== 11 || /^(\d)\1{10}$/.test(digitos)) {
    return false;
  }

  const verificador = (ate: number): number => {
    let soma = 0;

    for (let i = 0; i < ate; i++) {
      soma += Number(digitos[i]) * (ate + 1 - i);
    }

    const resto = (soma * 10) % 11;
    return resto === 10 ? 0 : resto;
  };

  return verificador(9) === Number(digitos[9]) && verificador(10) === Number(digitos[10]);
}

/** `00000000000` → `000.000.000-00`; o que não tiver 11 dígitos vira `''`. */
export function formatarCpf(valor?: string | null): string {
  const digitos = String(valor ?? '').replace(/\D/g, '');

  if (digitos.length !== 11) {
    return '';
  }

  return digitos.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
}
